import paper from './paper'
import book from './book'
import researchReport from './researchReport'
import artProduct from './artProduct'
import copyright from './copyright'
import patent from './patent'
import honor from './honor'

export default {
	paper,
	book,
	researchReport,
	artProduct,
	copyright,
	patent,
	honor
}